import UploadDocuments from '../../Programmatic/UploadDocuments';

const ContextualUploadDocuments = () => {
  return <UploadDocuments />;
};

export default ContextualUploadDocuments;
